import React, {Component} from "react";
import {List as ImmutableList, Map} from 'immutable';
import PropTypes from "prop-types";

import "./TabGroup.css"

class TabGroup extends Component {

	constructor(props) {
		super(props);
		this.onTabChange = this.onTabChange.bind(this);
	}

	onTabChange(e) {
		// e.preventDefault();
		this.props.onTabChange(e.target.value);
	}

	render() {
		return (
			<div className="tabgroup-container">
				<form className="tabgroup">
					{this.props.tabs.map( (item, index) => {

						return (
							<label className="tabgroup-tab" key={index}>
								<input
									onChange={this.onTabChange}
									type="radio"
									checked={item.get("checked")}
									value={item.get("value")}
									name="radio" />
								<span className="tabgroup-label">{item.get("label")}</span>
								<span className="tabgroup-indicator"></span>
							</label>
						)
					})
				}
			</form>
			</div>
		)
	}
}

TabGroup.propTypes = {
	tabs: PropTypes.object
}
TabGroup.defaultProps = {
	tabs: ImmutableList()
}
export default TabGroup;



// WEBPACK FOOTER //
// ./src/js/components/TabGroup.js